import { extend } from 'vee-validate';
import { email } from 'vee-validate/dist/rules';

export function isText(value: unknown, min: number, max: number): value is string {
    if (typeof value !== 'string' || !value.trim()) return false;
    const length = Array.from(value).length;
    return length >= min && length <= max;
}
export function isLogin(value: unknown, update = false): value is string {
    return isText(value, update ? 3 : 5, 50) && (update ? /^[a-zA-Z0-9._@-]+$/ : /^[a-zA-Z0-9._-]+$/).test(value);
}
export function isPassword(value: unknown): value is string {
    return isText(value, 5, 255) && /^[a-zA-Z0-9._-]+$/.test(value);
}
export function isPhone(value: unknown): value is string {
    return typeof value === 'string' && /^[+]?[0-9]{8,15}$/.test(value);
}
export function isEmail(value: unknown): value is string {
    return typeof value === 'string' && email.validate(value, { multiple: false }) === true;
}
export function isRouteId(value: unknown): value is number {
    return typeof value === 'number' && Number.isInteger(value) && value > 0 && value <= 9999999999;
}
export function isUserPayloadValid(payload: Record<string, unknown>, update: boolean, organisations: readonly number[]): boolean {
    return isRouteId(payload.organisationId) && organisations.includes(payload.organisationId)
        && ['admin', 'user'].includes(String(payload.type)) && typeof payload.type === 'string'
        && isLogin(payload.login, update) && (update && payload.password === null || isPassword(payload.password))
        && isText(payload.name, 5, 255) && isPhone(payload.phone) && isEmail(payload.email)
        && (!update || typeof payload.isActive === 'boolean');
}

/** Local rules matching reviewed DTOs; a backend-generated schema remains a separate task. */
export function registerFormRules(): void {
    extend('phone', { validate: isPhone });
    extend('login', { validate: value => isLogin(value) });
    extend('loginUpdate', { validate: value => isLogin(value, true) });
    extend('password', { validate: isPassword });
    extend('userName', { validate: value => isText(value, 1, Number.MAX_SAFE_INTEGER) });
    extend('unicodeLength', {
        params: ['min', 'max'],
        validate: (value, parameters) => {
            const min = Number(Array.isArray(parameters) ? parameters[0] : parameters.min);
            const max = Number(Array.isArray(parameters) ? parameters[1] : parameters.max);
            return Number.isInteger(min) && Number.isInteger(max) && min >= 0 && max >= min && isText(value, min, max);
        },
    });
}
